<template>
	<div v-if="selType">
		<div class="detailsView queueContainer" :class="['queueType'+selType, 'slot'+selSlot, {
			'usedSlot': selData,
			'lockedSlot': availableBuildQueueSlots < selSlot,
		}]" @mouseleave="onHideDetails()" @mouseover="onShowDetails(selType, selSlot)">
			<div class="detailsInnerBox">
				<div class="detailsHeader detailsRow">
					<div class="detailsImageContainer">
						<i class="headerIcon" :class="{
							'feature_buildingQueue_medium_illu': selType == BuildingQueue.TYPE_BUILD,
							'feature_buildingMaster_medium_illu': selType == BuildingQueue.TYPE_BUILD_QUEUE,
							'action_dismantle_medium_flat_black': selType == BuildingQueue.TYPE_DESTRUCTION && selData.isRubble,
							'action_demolish_medium_flat_black': selType == BuildingQueue.TYPE_DESTRUCTION && !selData.isRubble,
						}"></i>
					</div>
					<div class="headerText">
						<span v-if="selType == BuildingQueue.TYPE_DESTRUCTION">
							<span v-if="selData.isRubble">Разобрать руины</span>
							<span v-else>Снос</span>
						</span>
						<span v-if="selType == BuildingQueue.TYPE_BUILD">Строится...</span>
						<span v-if="selType == BuildingQueue.TYPE_BUILD_QUEUE">Очередь</span>
					</div>
				</div>
				<div
					class="detailsContent detailsRow"
					v-for="queueType in [selType]"
				>
					<div class="detailsImageContainer subContainer">
						<div
							v-if="selData"
							class="buildingSlotImage buildingMini"
							:class="['buildingType'+selData.buildingType, 'tribeId1', 'level'+selData.lvl]"
						></div>
						<i
							v-if="selData && !selData.isRubble"
							class="cancelBuilding clickable"
							play-on-click="6"
							clickable="cancelBuilding(609360)"
							v-tippy="{placement: 'top'}"
							:content="queueType == BuildingQueue.TYPE_BUILD_QUEUE ? 'Отменить улучшение' : (queueType == BuildingQueue.TYPE_BUILD ? 'Отменить постройку' : 'Отменить снос')"
						></i>
						<i
							v-if="queues[queueType].length == 0 && queueType == BuildingQueue.TYPE_BUILD"
							class="queueIcon builderIcon feature_buildingqueue_slot_combine_medium_flat_black"
							:class="{
								//'feature_buildingqueue_slot_combine_medium_flat_black': gameModel.buildingQueue.largeSlot,
								//'feature_buildingqueue_slot_village_medium_flat_black': !gameModel.buildingQueue.largeSlot && queueType == BuildingQueue.TYPE_BUILD,
								//'feature_buildingqueue_slot_fields_medium_flat_black': !gameModel.buildingQueue.largeSlot && queueType == BuildingQueue.TYPE_RESOURCES,
							}"
						></i>
						<div
							v-if="queueType == BuildingQueue.TYPE_BUILD_QUEUE && !selData"
							class="buildingQueueSlot entityBox noClick"
							:class="{
								empty: availableBuildQueueSlots >= selSlot,
								locked: availableBuildQueueSlots < selSlot,
							}"
						>
							<div v-if="availableBuildQueueSlots >= selSlot">
								<div class="topLeftBorder"></div>
								<div class="bottomRightBorder"></div>
								<i class="slotIcon builderIcon feature_buildqueue_small_flat_black"></i>
							</div>
							<i v-if="availableBuildQueueSlots < selSlot" class="slotIcon lockedState symbol_lock_small_flat_black"></i>
						</div>
					</div> 
					<div class="detailsInfo subContainer">
						<div v-if="selData">
							<span>{{selData.buildingName}}</span>
							<span v-if="queueType != BuildingQueue.TYPE_DESTRUCTION" class="levelText" data="current:10,
							next:11">
								<span>(10 </span>
								<i class="icon symbol_arrowTo_tiny_flat_black"></i>
								<span>&nbsp;11)</span>
							</span>
						</div>
						<div v-if="selData && gameModel.island.storage.hasEnoughResources(selData.cost) && ((selType != BuildingQueue.TYPE_DESTRUCTION && buildData?.timeStart >= 0) || (selType == BuildingQueue.TYPE_DESTRUCTION && selData?.timeStart >= 0))" class="detailsTime">
							<i class="symbol_clock_small_flat_black duration"></i>
							<span>&nbsp;
								<vue-countdown :time="(selType == BuildingQueue.TYPE_DESTRUCTION ? selRemainingTime : buildRemainingTime) * 1000" @end="" v-slot="{days, hours, minutes, seconds}">
									{{hours < 10 ? 0 : ''}}{{hours}}:{{minutes < 10 ? 0 : ''}}{{minutes}}:{{seconds < 10 ? 0 : ''}}{{seconds}}
								</vue-countdown>
							</span>
							<span v-if="queueType == BuildingQueue.TYPE_BUILD_QUEUE && selData.duration">
								<b>&nbsp;+</b> {{formatSecondsDate(selData.duration, 'HH:mm:ss')}}
							</span>
						</div>
						<div v-if="queueType == BuildingQueue.TYPE_BUILD_QUEUE && !selData && availableBuildQueueSlots < selSlot">
							<div class="slotStatus impediment">
								<span>Слот закрыт</span>
							</div>
							<span>Активируй этот слот, чтобы ставить в очередь дополнительные здания</span>
						</div>
						<div v-if="queueType == BuildingQueue.TYPE_BUILD_QUEUE && availableBuildQueueSlots >= selSlot">
							<div v-if="!selData">
								<span>Доступен слот № {{selSlot}}</span>
							</div>
							<div v-if="selData && !gameModel.island.storage.hasEnoughResources(selData.cost) && !selData.paid" class="slotStatus impediment">
								<span>Недостаточно ресурсов</span>
							</div>
						</div>
						<div v-if="queueType != BuildingQueue.TYPE_BUILD_QUEUE && !selData">
							<div>
								<span>Слот строительства</span>
							</div>
							<span class="slotStatus">Сейчас не используется</span>
						</div>
					</div>
					<div class="detailsButtonContainer subContainer" v-if="queueType == BuildingQueue.TYPE_BUILD_QUEUE">
						<!--сперва нужно открыть предыдущий слот-->
						<button class="premium clickable disabled" content="<span><strong>Слот в очереди строительства</strong><br><span>Сперва необходимо открыть предыдущий слот.</span></span>" v-tippy="{placement: 'top'}" v-if="(selSlot - availableBuildQueueSlots) > 1">
							<div class="content">
								<span class="innerText">
									<i class="symbol_plus_small_flat_black"></i>
								</span>
								<!-- ngIf: price > 0 || forceGoldUsage -->
								<!-- ngIf: price == -1 && !forceGoldUsage -->
								<div class="animationOverlay"></div>
								<i class="checkmark action_check_small_flat_white"></i>
								<i class="checkmark action_check_small_flat_black"></i>
								<i class="checkmark action_check_small_flat_red"></i>
							</div>
						</button>
						<!--открыть слот за 50 золотых-->
						<button clickable="openWindow('confirmGoldUsage', {'feature': PremiumFeature.FEATURE_NAME_BOOK_BUILD_MASTER_SLOT})" class="premium clickable" content="<span><strong>Слот в очереди строительства</strong> <br><span>Ты можешь открыть этот слот за 50 золота.</span></span>" v-tippy="{placement: 'top'}" v-else-if="(selSlot - availableBuildQueueSlots) > 0">
							<div class="content">
								<span class="innerText">
									<i class="symbol_plus_small_flat_black"></i>
								</span>
								<!-- ngIf: price > 0 || forceGoldUsage -->
								<!-- ngIf: price == -1 && !forceGoldUsage -->
								<div class="animationOverlay"></div>
								<i class="checkmark action_check_small_flat_white"></i>
								<i class="checkmark action_check_small_flat_black"></i>
								<i class="checkmark action_check_small_flat_red"></i>
							</div>
						</button>
						<button premium-feature="NPCTrader" confirm-gold-usage="true" ng-class="{disabled: activeVillage.isWWVillage() || slotDetails.npcTradingTimeBoost < 0}" class="premium" content="<strong>Обменять ресурсы автоматически <i class='icon unit_gold_small_illu'></i> 5</strong>" v-tippy="{placement: 'top'}" tooltip-translate-switch="{
							'Error.NotAvailableInWW': false,
							'Building.npcTrader.Tooltip.Possible': true,
							'Building.npcTrader.Tooltip.PossibleWithVoucher': 0,
							'Building.npcTrader.Tooltip.PossibleButNoEnoughRes': false,
							'Building.npcTrader.Tooltip.PossibleWithVoucherButNoEnoughRes': false,
							'Building.npcTrader.Tooltip.Insignificant': false
						}" tooltip-data="featurePrice:5,timePeriod:0" v-else-if="selData && gameModel.inventory.checkExistsByType(Inventory.TYPE_NPC_TRADER) && !gameModel.island.storage.hasEnoughResources(selData.cost) && !selData.paid">
							<div class="content">
								<span class="innerText">
									<i class="feature_npcTrader_small_flat_black" ng-class="{disabled: activeVillage.isWWVillage() || slotDetails.npcTradingTimeBoost}"></i>
								</span>
								<span class="price gold" ng-if="price > 0 || forceGoldUsage"><i class="unit_gold_small_illu"></i>5</span>
								<!-- ngIf: price == -1 && !forceGoldUsage -->
								<div class="animationOverlay"></div>
								<i class="checkmark action_check_small_flat_white"></i>
								<i class="checkmark action_check_small_flat_black"></i>
								<i class="checkmark action_check_small_flat_red"></i>
							</div>
						</button>
						<button clickable="reserveResources(609365)" ng-class="{disabled: !slotDetails.canPayNow}" content="Зарезервировать ресурсы" v-tippy="{placement: 'top'}" tooltip-translate-switch="{
							'BuildingQueue.Details.Tooltip.ReserveResources': true,
							'BuildingQueue.Details.Tooltip.ReservePrevious': false
						}" class="clickable" v-else-if="selData && gameModel.island.storage.hasEnoughResources(selData.cost) && !selData.paid">
							<div class="content">
								<span class="innerText">
									<i class="unit_resources_medium_illu" ng-class="{disabled: !slotDetails.canPayNow}"></i>
								</span>
								<!-- ngIf: price > 0 || forceGoldUsage -->
								<!-- ngIf: price == -1 && !forceGoldUsage -->
								<div class="animationOverlay"></div>
								<i class="checkmark action_check_small_flat_white"></i>
								<i class="checkmark action_check_small_flat_black"></i>
								<i class="checkmark action_check_small_flat_red"></i>
							</div>
						</button>
					</div>
					<div class="detailsButtonContainer subContainer" v-else>
						<!--если можно завершить сразу (осталось 5 и менее минут)-->
						<button premium-feature="finishNow" class="free" premium-callback-param="finishNowQueueType:1" confirm-gold-usage="true" :content="tooltips[5]" v-tippy="{placement: 'top'}" tooltip-url="tpl/npcTrader/finishNowTooltip.html" ng-repeat="n in [buildingQueue.data.queues[queueType][slotDetails.slot].id]"  v-if="selData && selRemainingTime < (60 * 5)">
							<div class="content">
								<span class="innerText">
									<i class="feature_instantCompletion_small_flat_black"></i>
								</span>
								<!-- ngIf: price > 0 || forceGoldUsage -->
								<!-- ngIf: price == -1 && !forceGoldUsage -->
								<div class="animationOverlay"></div>
								<i class="checkmark action_check_small_flat_white"></i>
								<i class="checkmark action_check_small_flat_black"></i>
								<i class="checkmark action_check_small_flat_red"></i>
							</div>
						</button>
						<!--если можно завершить сразу за бонус карту-->
						<button premium-feature="finishNow" class="free" premium-callback-param="finishNowQueueType:1" confirm-gold-usage="true" :content="tooltips[5]" v-tippy="{placement: 'top'}" tooltip-url="tpl/npcTrader/finishNowTooltip.html" ng-repeat="n in [buildingQueue.data.queues[queueType][slotDetails.slot].id]" v-else-if="selData && gameModel.inventory.checkExistsByType(Inventory.TYPE_FINISH_IMMEDIATELY)">
							<div class="content">
								<span class="innerText">
									<i class="feature_instantCompletion_small_flat_black"></i>
								</span>
								<!-- ngIf: price > 0 || forceGoldUsage -->
								<span class="price voucher" ng-if="price == -1 && !forceGoldUsage"><i class="cardGame_prizePremium_small_illu"></i><span>1</span></span>
								<div class="animationOverlay"></div>
								<i class="checkmark action_check_small_flat_white"></i>
								<i class="checkmark action_check_small_flat_black"></i>
								<i class="checkmark action_check_small_flat_red"></i>
							</div>
						</button>
						<!--если завершать за золото-->
						<button premium-feature="finishNow" class="premium" premium-callback-param="finishNowQueueType:5" confirm-gold-usage="true" :content="tooltips[1]" v-tippy="{placement: 'top'}" tooltip-url="tpl/npcTrader/finishNowTooltip.html" ng-repeat="n in [buildingQueue.data.queues[queueType][slotDetails.slot].id]" v-else-if="selData">
							<div class="content">
								<span class="innerText">
									<i class="feature_instantCompletion_small_flat_black"></i>
								</span>
								<span class="price gold" ng-if="price > 0 || forceGoldUsage"><i class="unit_gold_small_illu"></i>5</span>
								<!-- ngIf: price == -1 && !forceGoldUsage -->
								<div class="animationOverlay"></div>
								<i class="checkmark action_check_small_flat_white"></i>
								<i class="checkmark action_check_small_flat_black"></i>
								<i class="checkmark action_check_small_flat_red"></i>
							</div>
						</button>
					</div>
					<div class="progressbar" v-if="queueType != BuildingQueue.TYPE_BUILD_QUEUE && selData">
						<div class="progress">
							<div class="bar perc" :class="{
								positive: selType != BuildingQueue.TYPE_DESTRUCTION,
								negative: selType == BuildingQueue.TYPE_DESTRUCTION,
							}" style="z-index: 2;" :style="{width: selPercentage+'%'}"></div>
							<div class="bar additionalBar additionalPerc"></div>
							<div class="marker">
								<div class="markerInner"></div>
							</div>
							<div class="tooltipArea" :content="selPercentage+'%'" v-tippy="{placement: 'top'}"></div>
						</div>
					</div>
				</div>
				<div class="detailsRow" v-if="selType == BuildingQueue.TYPE_BUILD_QUEUE && selData" :class="{
					paid: selData.paid,
				}">
					<display-resources
						:resources="selData.cost"
						:hide-zero="true"
						:game-model="gameModel"
					/>
				</div>
				<div class="detailsRow" v-if="selType == BuildingQueue.TYPE_DESTRUCTION && selData.isRubble">
					<display-resources
						:resources="selData.cost"
						:color-positive="true"
						:check-storage="true"
						:hide-zero="true"
						:game-model="gameModel"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

import BuildingQueue from '@/classes/game/BuildingQueue';
import Inventory from '@/classes/game/Inventory';
import Player from '@/classes/game/Player';

import DisplayResources from '@/components/elements/DisplayResources';

export default {
	mixins: lib.mixins,
	data: () => ({
		BuildingQueue,
		Inventory,
		Player,
		
		tooltips: {
			1: `<div class="finishNowTooltip" ng-controller="finishNowCtrl">
	<!-- ngIf: !isWorldWonder && (inBuilding.length>0 || inTraining.length>0 || inDestruction.length>0 || inResearch.length>0) --><div ng-if="!isWorldWonder && (inBuilding.length>0 || inTraining.length>0 || inDestruction.length>0 || inResearch.length>0)">
		<h3>
			<span><span>Моментально завершить следующие поручения</span></span><!-- ngIf: price == 0 -->
			<!-- ngIf: price > 0 || forceGoldUsage --><span class="price" ng-if="price > 0 || forceGoldUsage"><i class="unit_gold_small_illu"></i>2:</span><!-- end ngIf: price > 0 || forceGoldUsage -->
			<!-- ngIf: price == -1 && !forceGoldUsage -->
		</h3>
		<div class="horizontalLine"></div>

		<!-- ngRepeat: build in inBuilding track by $index --><div ng-repeat="build in inBuilding track by $index">
			<!-- ngIf: !finishNowQueueType -->
			<span options="22"><span>Академия</span></span>
			<span class="level" data="lvl:20"><span>Уровень 20</span></span>
		</div><!-- end ngRepeat: build in inBuilding track by $index -->
		<!-- ngRepeat: destruction in inDestruction track by $index -->
		<!-- ngRepeat: research in inResearch track by $index -->
		<!-- ngRepeat: training in inTraining track by $index -->
	</div><!-- end ngIf: !isWorldWonder && (inBuilding.length>0 || inTraining.length>0 || inDestruction.length>0 || inResearch.length>0) -->
	<!-- ngIf: isWorldWonder -->
	<!-- ngIf: !isWorldWonder && hasInvalidBuilding && !config.balancing.specialRules.cropDiet -->
	<!-- ngIf: !isWorldWonder && hasInvalidBuilding && config.balancing.specialRules.cropDiet -->
	<!-- ngIf: !isWorldWonder && !hasInvalidBuilding && inBuilding.length == 0 && inTraining.length == 0 && inDestruction.length == 0 && inResearch.length == 0 -->
	<!-- ngIf: !isWorldWonder && premiumOptionMenu.options.instantCompletion && !freeSlots && enoughRes === false -->
</div>`,
			2: `<strong>Обменять ресурсы автоматически <i class="icon unit_gold_small_illu"></i> 5</strong>`,
			5: `<div class="finishNowTooltip" ng-controller="finishNowCtrl">
	<!-- ngIf: !isWorldWonder && (inBuilding.length>0 || inTraining.length>0 || inDestruction.length>0 || inResearch.length>0) --><div ng-if="!isWorldWonder &amp;&amp; (inBuilding.length>0 || inTraining.length>0 || inDestruction.length>0 || inResearch.length>0)">
		<h3>
			<span translate=""><span>Моментально завершить следующие поручения</span></span><!-- ngIf: price == 0 --><span ng-if="price == 0">:</span><!-- end ngIf: price == 0 -->
			<!-- ngIf: price > 0 || forceGoldUsage -->
			<!-- ngIf: price == -1 && !forceGoldUsage -->
		</h3>
		<div class="horizontalLine"></div>

		<!-- ngRepeat: build in inBuilding track by $index --><div ng-repeat="build in inBuilding track by $index">
			<!-- ngIf: !finishNowQueueType -->
			<span translate="" options="17"><span>Рынок</span></span>
			<span class="level" translate="" data="lvl:2"><span>Уровень 2</span></span>
		</div><!-- end ngRepeat: build in inBuilding track by $index -->
		<!-- ngRepeat: destruction in inDestruction track by $index -->
		<!-- ngRepeat: research in inResearch track by $index -->
		<!-- ngRepeat: training in inTraining track by $index -->
	</div><!-- end ngIf: !isWorldWonder && (inBuilding.length>0 || inTraining.length>0 || inDestruction.length>0 || inResearch.length>0) -->
	<!-- ngIf: isWorldWonder -->
	<!-- ngIf: !isWorldWonder && hasInvalidBuilding && !config.balancing.specialRules.cropDiet -->
	<!-- ngIf: !isWorldWonder && hasInvalidBuilding && config.balancing.specialRules.cropDiet -->
	<!-- ngIf: !isWorldWonder && !hasInvalidBuilding && inBuilding.length == 0 && inTraining.length == 0 && inDestruction.length == 0 && inResearch.length == 0 -->
	<!-- ngIf: !isWorldWonder && premiumOptionMenu.options.instantCompletion && !freeSlots && enoughRes === false -->
</div>`,
		},
	}),
	computed: {
		selType() {
			return this.gameModel.buildingQueue.activeSlot.slotHover || this.gameModel.buildingQueue.activeSlot.detailHover;
		},
		selSlot() {
			return this.gameModel.buildingQueue.activeSlot.slot || this.gameModel.buildingQueue.activeSlot.slotDetail;
		},
		selData() {
			if (this.selType) {
				return this.queues[this.selType].find(el => el.slot == this.selSlot) || null;
			}
			return null;
		},
		buildData() {
			return this.queues[BuildingQueue.TYPE_BUILD].length > 0 ? this.queues[BuildingQueue.TYPE_BUILD][0] : null;
		},
		selRemainingTime() {
			if (!this.selData) return 0;
			
			// Текущее время в формате Unix timestamp
			const currentTime = Math.floor(Date.now() / 1000);

			// Рассчитываем конечное время
			//const endTime = this.selData.timeStart + this.selData.duration;
			const endTime = this.selData.timeFinish;

			// Рассчитываем оставшееся время
			const remainingTime = endTime - currentTime;
			
			return remainingTime > 0 ? remainingTime : 0;
		},
		buildRemainingTime() {
			if (!this.buildData) return 0;
			
			// Текущее время в формате Unix timestamp
			const currentTime = Math.floor(Date.now() / 1000);

			// Рассчитываем конечное время
			//const endTime = this.buildData.timeStart + this.buildData.duration;
			const endTime = this.buildData.timeFinish;

			// Рассчитываем оставшееся время
			const remainingTime = endTime - currentTime;
			
			return remainingTime > 0 ? remainingTime : 0;
		},
		selPercentage() {
			if (!this.selData) return 0;
			
			// Текущее время в формате Unix timestamp
			const currentTime = Math.floor(Date.now() / 1000);

			// Рассчитываем конечное время
			const startTime = this.selData.timeFinish - this.selData.duration;

			// Рассчитываем оставшееся время
			const elapsedTime = currentTime - startTime;
			
			return Math.min((elapsedTime / this.selData.duration) * 100, 100);
		},
		queues() {
			return this.gameModel.buildingQueue.queues;
		},
		availableBuildQueueSlots() {
			return this.gameModel.buildingQueue.availableBuildQueueSlots;
		},
	},
	methods: {
		formatSecondsDate: lib.formatSecondsDate,
		
		onHideDetails() {//mouseleave
			this.gameModel.buildingQueue.activeSlot.detailHover = null;
			this.gameModel.buildingQueue.activeSlot.slotDetail = null;
		},
		onShowDetails(queueType, slot = null) {//mouseover
			this.gameModel.buildingQueue.activeSlot.detailHover = queueType;
			this.gameModel.buildingQueue.activeSlot.slotDetail = slot;
		},
	},
	components: {
		DisplayResources,
	},
}
</script>